import { memo, useEffect } from "react";
import { LoadingMark } from "./LoadingMark";
import {
  hideBootSplash,
  isBootSplashHidden,
  subscribeBootSplashHidden,
} from "../../lib/boot-splash";

function BootSplash() {
  useEffect(() => {
    if (isBootSplashHidden()) {
      hideBootSplash();
    }
    return subscribeBootSplashHidden(() => {
      hideBootSplash();
    });
  }, []);

  return (
    <div id="js-boot-splash" suppressHydrationWarning>
      <LoadingMark />
    </div>
  );
}

export default memo(BootSplash);
